import { render, staticRenderFns } from "./SisIconStatus.vue?vue&type=template&id=651df39e&"
import script from "./SisIconStatus.vue?vue&type=script&lang=js&"
export * from "./SisIconStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports